import CityPageTemplate from "../city-template/CityPageTemplate";
import { brownsvilleConfig } from "./data";

export default function BrownsvillePage() {
  return <CityPageTemplate config={brownsvilleConfig} />;
}